module.exports = __webpack_public_path__ + "static/L5Y7-785c5e45a32cb2909bfe9d12a63aca50.jpg";